import React, {Component} from 'react'

import styled from "styled-components"
import {createStructuredSelector} from "reselect"
import {connect} from "react-redux"
import {
  selectAssignmentTransactionHash, selectLatestQualiaOrder,
  selectSelectedProviderAddress,
  selectSelectedProviderIsQualiaSupported,
  selectSelectedSettlementProviderName
} from "manager/selectors/referral_selectors"
import {ORDER_CANCELED_REJECTED} from "manager/views/components/Settlement/constants"
import {removeSettlementProviderSelection} from "manager/redux/referral"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"

const SelectedProviderContainer = styled(SettlementCard)`
`

const TextDiv = styled.div`
  color: #8C8C8C;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  margin-top: 20px;
`

const AddressDiv = styled.div`
  color: #4A4A4A
  font-size: 16px;
  line-height: 20px;
  font-weight: normal;
  margin-top: 8px;
  width: 160px;
`

const TitleRemoveDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 6px;
  margin-bottom: 20px;
`

const TitleDiv = styled.div`
  font-size: 26px;
  font-weight: bold;
  line-height: 33px;
`

const RemoveA = styled.a`
  font-weight: 300;
  line-height: 20px;
  text-align: right;
`

class SelectedProvider extends Component {
  removeSelectedProvider = () => {
    const {dispatch, hash} = this.props
    dispatch(removeSettlementProviderSelection(hash))
  }

  render() {
    const {selectedProviderAddress, selectedSettlementProviderName, isQualiaSupported, qualia_order} = this.props

    let qualia_status = qualia_order ? qualia_order.status : null

    return (
      <SelectedProviderContainer paddingLeftRight='60px' marginTop='0px'>
        <TextDiv>Your Selected Provider</TextDiv>
        <TitleRemoveDiv>
          <TitleDiv>
            {selectedSettlementProviderName}
            {isQualiaSupported && <AddressDiv>{selectedProviderAddress}</AddressDiv>}
          </TitleDiv>
          {(!qualia_status || ORDER_CANCELED_REJECTED.indexOf(qualia_status) > -1) &&
          <RemoveA onClick={this.removeSelectedProvider}>Remove</RemoveA>}
        </TitleRemoveDiv>
      </SelectedProviderContainer>
    )
  }

}

const selector = createStructuredSelector({
  hash: selectAssignmentTransactionHash,
  selectedSettlementProviderName: selectSelectedSettlementProviderName,
  isQualiaSupported: selectSelectedProviderIsQualiaSupported,
  selectedProviderAddress: selectSelectedProviderAddress,
  qualia_order: selectLatestQualiaOrder,
})

export default connect(selector)(SelectedProvider)
